export default "__VITE_ASSET__CfTFLnAH__"